import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotifications } from "../../../../../redux/notificationSlice/notificationSlice";

export default function Notifications() {
  const dispatch = useDispatch();
  const { allNotifications } = useSelector((state) => state.notification);
  useEffect(() => {
    dispatch(getAllNotifications());
  }, []);
  const getTimeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) return `منذ ${diffInSeconds} ثانية`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `منذ ${diffInMinutes} دقيقة`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `منذ ${diffInHours} ساعة`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) return `منذ ${diffInDays} يوم`;
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return `منذ ${diffInMonths} شهر`;
    const diffInYears = Math.floor(diffInMonths / 12);
    return `منذ ${diffInYears} سنة`;
  };

  return (
    <>
      <div className="p-3 notifications card">
        <h3>
          <i className="fa-solid fa-bell me-3 text-warning"></i>
          الإشعارات
        </h3>
        {allNotifications?.slice(0, 3)?.map((notification, index) => (
          <>
            <div className="alert">
              <p>{notification?.message}</p>
              <span>{getTimeAgo(notification?.createdAt)}</span>
            </div>
            {index == 2 ? null : <hr />}
          </>
        ))}
      </div>
    </>
  );
}
